module.exports = __webpack_public_path__ + "media/images/category/feature/echigo/hero-e5b27816cd92bdec8f428f7c3d3692b3.jpg";